
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.056 18H.944a.969.969 0 01-.667-.264A.88.88 0 010 17.1V.9C0 .661.1.432.277.264A.969.969 0 01.944 0h15.112c.25 0 .49.095.667.264A.88.88 0 0117 .9v16.2a.88.88 0 01-.277.636.969.969 0 01-.667.264zm-.945-1.8V1.8H1.89v14.4H15.11zM4.722 4.5h7.556v1.8H4.722V4.5zm0 3.6h7.556v1.8H4.722V8.1zm0 3.6h7.556v1.8H4.722v-1.8z","fill":"#FAAD14"}})])
          )
        }
      }
    